import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Suikoden II any%" mdxType="SEO" />
    <h3 {...{
      "id": "tenzan-pass"
    }}>{`Tenzan Pass`}</h3>
    <p><em parentName="p">{`"So anyway... should we go to sleep soon?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Set text speed to Fast`}</p>
    <p><strong parentName="p">{`4 Highland Soldier`}</strong><br parentName="p"></br>{`
`}{`Unite then auto`}</p>
    <h4 {...{
      "id": "after-first-battle"
    }}>{`After first battle`}</h4>
    <p><em parentName="p">{`"Hero, there is no other way."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`"Promise me, Hero"`}</em>{` Option 1`}</p>
    <h3 {...{
      "id": "mercenary-fort"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Blacksmith `}<strong parentName="p">{`Option 3`}</strong>{` then Flint acquired text + 1 textbox`}<br parentName="p"></br>{`
`}{`Barbara `}<strong parentName="p">{`Option 3`}</strong>{` then Boots acquired text + 1 textbox`}<br parentName="p"></br>{`
`}{`Shopkeeper Just 1 Textbox careful mashing here`}</p>
    <h3 {...{
      "id": "world-map"
    }}>{`World Map`}</h3>
    <p>{`Appear above fort`}</p>
    <h3 {...{
      "id": "ryube"
    }}>{`Ryube`}</h3>
    <p>{`Go to shop`}</p>
    <h3 {...{
      "id": "mercenary-fort-1"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Talk to Oil spills from top right except Flik's room bottom right`}</p>
    <p><strong parentName="p">{`After Jowy rescue`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Flik > "That's far enough", Jowy > "We... we're outnumbered."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Flik > Viktor > Jowy "Well that's..." > Viktor "What the hell happened?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "world-map-1"
    }}>{`World Map`}</h3>
    <p>{`Start below Mercenary Fort`}</p>
    <h3 {...{
      "id": "ryube-1"
    }}>{`Ryube`}</h3>
    <p><em parentName="p">{`Eilie > "Here we go!"`}</em>{` Knife-Throwing `}<strong parentName="p">{`Option 2 or 3`}</strong></p>
    <h4 {...{
      "id": "formation"
    }}>{`Formation`}</h4>
    <ol>
      <li parentName="ol">{`Hero > Rina`}</li>
      <li parentName="ol">{`Bolgan > Jowy`}</li>
    </ol>
    <h3 {...{
      "id": "north-sparrow-pass"
    }}>{`North Sparrow Pass`}</h3>
    <p>{`Pickup Fire Wall`}<br parentName="p"></br>{`
`}{`Heal and equip for Mist Monster`}</p>
    <h4 {...{
      "id": "equipment"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Rina`}</strong><br parentName="p"></br>{`
`}{`Best Equip`}<br parentName="p"></br>{`
`}{`Angry Blow > Jowy's Boots`}<br parentName="p"></br>{`
`}{`Medicine > Hero's Boots`}</p>
    <p><strong parentName="p">{`Bolgan`}</strong><br parentName="p"></br>{`
`}{`Jizo > Medicine`}</p>
    <p><strong parentName="p">{`Eilie`}</strong><br parentName="p"></br>{`
`}{`Medicine > Firewall`}<br parentName="p"></br>{`
`}{`Gloves > Jowy's Medicine`}</p>
    <p><strong parentName="p">{`Hero`}</strong><br parentName="p"></br>{`
`}{`Medicine Slot 1 > Flaming Arrows`}</p>
    <blockquote>
      <p parentName="blockquote">{`The slot might matter for Best Equip in Ryube Forest, not confirmed.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mist-monster-800hp"
    }}>{`Mist Monster (800HP)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Turn 1`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Turn 2`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Flaming Arrows`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Circus Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Circus`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Fire Wall`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Circus`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Flaming Arrows`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Jowy: Angry Blow`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Jowy: Angry Blow`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "kyaro"
    }}>{`Kyaro`}</h3>
    <p><strong parentName="p">{`Soldier Fight`}</strong><br parentName="p"></br>{`
`}{`Hero: Flaming Arrow`}</p>
    <p><em parentName="p">{`Viktor: "Damn, he ran away!", Jowy: "Wait, wait a minute."`}</em>{` `}<strong parentName="p">{`Option 2x3`}</strong></p>
    <h3 {...{
      "id": "mercenary-fort-2"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Exit right away`}</p>
    <h3 {...{
      "id": "world-map-2"
    }}>{`World Map`}</h3>
    <p>{`Appear below Mercenary Fort, hold down then left`}</p>
    <h3 {...{
      "id": "toto"
    }}>{`Toto`}</h3>
    <p>{`Talk to the innkeeper 17 times and exit Toto `}<em parentName="p">{`talk to left side of book`}</em><br parentName="p"></br>{`
`}{`After leaving Pilika's house can hold left, won't run into girl.`}</p>
    <h3 {...{
      "id": "muse"
    }}>{`Muse`}</h3>
    <h4 {...{
      "id": "shop"
    }}>{`Shop`}</h4>
    <p><em parentName="p">{`Jowy:"What should we do?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h5 {...{
      "id": "buy"
    }}>{`Buy`}</h5>
    <p>{`Escape Talisman`}</p>
    <h3 {...{
      "id": "toto--world-map--mercenary-fort"
    }}>{`Toto > World Map > Mercenary Fort`}</h3>
    <h4 {...{
      "id": "blacksmith"
    }}>{`Blacksmith`}</h4>
    <p>{`Sharpen Hero's Weapon to 3`}<br parentName="p"></br>{`
`}{`Flik gives you 2k, Apple, Jowy: "Let's go, Hero." > `}<em parentName="p">{`Walk around Flik`}</em></p>
    <h3 {...{
      "id": "ryube-forest"
    }}>{`Ryube Forest`}</h3>
    <p>{`Need to kill either a 5x Spider battle or 3x Slug battle`}</p>
    <p>{`3 Slug:   Jowy Flaming Arrow`}<br parentName="p"></br>{`
`}{`5 Spider: Buddy Attack twice`}</p>
    <p><em parentName="p">{`After the battle try to check Hero & Jowy's speed. Want Jowy to be faster.`}</em></p>
    <p>{`Pick up 2 Chests in top left corner`}</p>
    <h4 {...{
      "id": "equipment-1"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Hero`}</strong><br parentName="p"></br>{`
`}{`Best Equip x2`}</p>
    <blockquote>
      <p parentName="blockquote">{`If Tsai in Party can remove his Leather Hat & Coat and Best Equip Hero`}</p>
    </blockquote>
    <p>{`After Ryube is burned down `}<em parentName="p">{`Tsai, Jowy, Tsai`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "mercenary-fort-3"
    }}>{`Mercenary Fort`}</h3>
    <p>{`Heal Hero if he's not full HP`}</p>
    <p><em parentName="p">{`Meeting room`}</em>{` After Jowy and Pilika come inside you `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "flik-duel"
    }}>{`Flik Duel`}</h4>
    <p><em parentName="p">{`Header is your action`}</em></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`C'mon take a swing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Here goes! Hope you can`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nice try, I'll go`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Don't get too confident`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Here it comes. Better`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, let's see`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, it's your turn`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, maybe I should show`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whoa, nice strike`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`One more time. Don't`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You dodged my sword,`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes, good. What'll`}</td>
        </tr>
      </tbody>
    </table>
    <p><em parentName="p">{`Jowy: "What should we do?"`}</em>{` `}<strong parentName="p">{`Name Army`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Viktor: "Are you two ready?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "war-battle-1"
    }}>{`War Battle #1`}</h3>
    <h4 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h4>
    <p>{`1 Textbox then Select > End Turn`}</p>
    <h4 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h4>
    <p>{`Menu > End Turn`}</p>
    <h3 {...{
      "id": "war-battle-2"
    }}>{`War Battle #2`}</h3>
    <p><em parentName="p">{`Viktor, Flik, Viktor`}</em>{` `}<strong parentName="p">{`Option 2`}</strong>{` to start`}</p>
    <p>{`Move Riou 2 down if Flik doesn't block, will spawn unit & end war battle instantly.`}<br parentName="p"></br>{`
`}{`Riou has 1 Fire Spear, can maybe use to injure Flik?`}</p>
    <h3 {...{
      "id": "mercenary-fort-4"
    }}>{`Mercenary Fort`}</h3>
    <p>{`If Jowy SPD == Hero SPD formation swap Hero & Jowy`}</p>
    <p><strong parentName="p">{`2x 4 Soldier Battle`}</strong><br parentName="p"></br>{`
`}{`Flaming Arrow if you have it otherwise Buddy Attack`}<br parentName="p"></br>{`
`}<em parentName="p">{`If using Flaming Arrow and Jowy is faster Hero attack otherwise Hero Defend`}</em></p>
    <h3 {...{
      "id": "world-map-toto"
    }}>{`World Map Toto`}</h3>
    <p>{`Mash through cutscene`}</p>
    <h3 {...{
      "id": "muse-1"
    }}>{`Muse`}</h3>
    <p>{`If you swapped Jowy & Hero at fort don't change formation. Otherwise,`}</p>
    <h4 {...{
      "id": "formation-1"
    }}>{`Formation`}</h4>
    <p>{`Hero > Jowy`}<br parentName="p"></br>{`
`}{`Hero > Gengen`}</p>
    <h3 {...{
      "id": "white-deer-inn"
    }}>{`White Deer Inn`}</h3>
    <p><em parentName="p">{`Alex "...Hmmm", Alex checks you out, "Okay. I'll make you an offer."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "sindar-ruins"
    }}>{`Sindar Ruins`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Don't need Fire Lizard, plate is screen before Fire Lizard`}</p>
    </blockquote>
    <p>{`Level up battles are 5 MegaWatt or 4 Salamander`}<br parentName="p"></br>{`
`}{`Both Shining Light 1st turn`}</p>
    <h4 {...{
      "id": "equipment-2"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Nanami`}</strong><br parentName="p"></br>{`
`}{`Feathered Cap > Inventory`}</p>
    <p><strong parentName="p">{`Hero`}</strong><br parentName="p"></br>{`
`}{`Remove everything but Medicine`}</p>
    <p><strong parentName="p">{`Gengen`}</strong><br parentName="p"></br>{`
`}{`Leather Hat > Inventory (Unless you removed Tsai's earlier)`}<br parentName="p"></br>{`
`}{`Leather Coat > Inventory`}<br parentName="p"></br>{`
`}{`Wooden Shield > Inventory`}</p>
    <p><strong parentName="p">{`Jowy`}</strong><br parentName="p"></br>{`
`}{`Best Equip`}</p>
    <blockquote>
      <p parentName="blockquote">{`TODO: Battle explanation / tutorial here.`}</p>
    </blockquote>
    <p>{`Pick up Chainmail`}</p>
    <h4 {...{
      "id": "equipment-3"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Jowy`}</strong><br parentName="p"></br>{`
`}{`Best Equip`}</p>
    <h4 {...{
      "id": "double-head-2500hp"
    }}>{`Double Head (2500HP)`}</h4>
    <p><strong parentName="p">{`Turn 1-3`}</strong><br parentName="p"></br>{`
`}{`Jowy Best Magic`}</p>
    <h3 {...{
      "id": "muse-2"
    }}>{`Muse`}</h3>
    <p>{`Viktor joins before Annabelle `}<em parentName="p">{`don't change formation`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`Jess, Jowy walks forward "What do you think?"`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "party"
    }}>{`Party`}</h4>
    <p>{`Gengen`}<br parentName="p"></br>{`
`}{`Tsai`}</p>
    <blockquote>
      <p parentName="blockquote">{`This Formation change helps with EQP menu. Want order to be Jowy, Nanami,`}<br parentName="p"></br>{`
`}{`Hero. There's a delay of about 2.5s before you can close the formation menu`}<br parentName="p"></br>{`
`}{`after party menu. As long the swap is done quick, there's no time cost in doing this.`}</p>
    </blockquote>
    <h4 {...{
      "id": "formation-2"
    }}>{`Formation`}</h4>
    <p>{`Hero > Nanami`}</p>
    <h3 {...{
      "id": "muse-highland-border"
    }}>{`Muse-Highland Border`}</h3>
    <p>{`Talk to right guard, then talk to him again.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Can do Equipment menu anytime between picking party & entering Highland Camp`}</p>
    </blockquote>
    <h4 {...{
      "id": "equipment-4"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Jowy`}</strong><br parentName="p"></br>{`
`}{`Feathered Cap > Inventory`}<br parentName="p"></br>{`
`}{`Chainmail > Inventory`}</p>
    <p><strong parentName="p">{`Nanami`}</strong><br parentName="p"></br>{`
`}{`Best Equip`}<br parentName="p"></br>{`
`}{`Weakest Accessory that's not Medicine > Tsai's Clay Guardian`}</p>
    <p><strong parentName="p">{`Hero`}</strong><br parentName="p"></br>{`
`}{`Best Equip`}<br parentName="p"></br>{`
`}{`Equip Sacrificial Jizo`}</p>
    <p><strong parentName="p">{`Soldier Battles`}</strong><br parentName="p"></br>{`
`}{`First battle Jowy LVL2 Spell Twinkling Blade`}<br parentName="p"></br>{`
`}{`Second battle Hero Shining Light`}</p>
    <h3 {...{
      "id": "muse-3"
    }}>{`Muse`}</h3>
    <p>{`Go to Town Hall, then Inn, then Town Hall, then Inn`}<br parentName="p"></br>{`
`}{`Exit Muse `}<em parentName="p">{`Nanami 2 textboxes`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Jowston Hill`}<br parentName="p"></br>{`
`}{`At Inn `}<em parentName="p">{`Jowy, Annabelle, Jowy`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Talk to Viktor Option 1`}</p>
    <h3 {...{
      "id": "war-battle-3"
    }}>{`War Battle #3`}</h3>
    <p>{`End Turn every turn`}<br parentName="p"></br>{`
`}{`Battle ends when you end your turn after Knights retreat`}</p>
    <h3 {...{
      "id": "muse-4"
    }}>{`Muse`}</h3>
    <p>{`Talk to Nanami `}<em parentName="p">{`1 textbox "Hey Hero..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Town Hall then Inn`}<br parentName="p"></br>{`
`}{`Inn 2nd Floor talk to Nanami `}<em parentName="p">{`1 textbox "Hey Hero..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Go to Town Hall then Exit Muse`}</p>
    <h3 {...{
      "id": "coronet"
    }}>{`Coronet`}</h3>
    <p>{`Go to southwest dock then Inn 2nd floor then Tai Ho`}<br parentName="p"></br>{`
`}{`Go to inn & get Circus crew`}</p>
    <p><em parentName="p">{`Watch Rina MGC, want Rina + Hero MGC >= 146 so Firewall + Shining Light kills Phantoms`}</em></p>
    <h4 {...{
      "id": "formation-3"
    }}>{`Formation`}</h4>
    <p>{`Nanami > Rina`}</p>
    <p>{`After getting Circus head towards Muse-Matilda border & Matilda Glitch`}</p>
    <blockquote>
      <p parentName="blockquote">{`Note: Keep track of Eilie's deaths. After Abomination she should be at 3.`}</p>
    </blockquote>
    <h3 {...{
      "id": "muse-matilda-border--world-map"
    }}>{`Muse-Matilda Border > World Map`}</h3>
    <p>{`Any battle except 6 Phantoms works`}<br parentName="p"></br>{`
`}{`For groups of 2-3 need to kill off everyone except Hero.`}<br parentName="p"></br>{`
`}{`With groups of 4 either Bolgan or Rina can survive.`}</p>
    <p>{`Run to Rockaxe, grind for battle before entering Rockaxe if you haven't gotten one already.`}</p>
    <h5 {...{
      "id": "vs-pink-birds"
    }}>{`VS Pink Birds`}</h5>
    <blockquote>
      <p parentName="blockquote">{`Pink Bird AI makes them attack each available target once. They will not repeat targets. Use this to predict when party will die.`}</p>
    </blockquote>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 1`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 2 and on`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Shining Light`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Defend / Shining Light`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Attack / Item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Attack / Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Medicine Hero`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Attack / Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Nanami: Shift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nanami: Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Shift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Attack`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`When party is about to die, use Shining Light.`}</p>
    <h5 {...{
      "id": "vs-2-3-phantoms"
    }}>{`VS 2-3 Phantoms`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 1`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 2 and on`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Defend / Shining Light`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Fire Wall`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Attack / Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Medicine Hero`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Attack / Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Nanami: Attack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nanami: Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Shift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Attack`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`When party is about to die, use Shining Light.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Like birds, Phantoms won't repeat targets with their 1 target attack.`}<br parentName="p"></br>{`
`}{`They also have a row attack, which has a 50% chance of hitting each row.`}<br parentName="p"></br>{`
`}{`Harder to predict when they will kill your party.`}</p>
    </blockquote>
    <h5 {...{
      "id": "vs-4-phantoms"
    }}>{`VS 4 Phantoms`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 1`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 2 and on`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Shining Light`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Defend / Shining Light`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Flaming Arrows`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Attack / Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Medicine Hero`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Attack / Item`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Nanami: Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nanami: Attack / Medicine / Clay Hero`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Shift / Medicine Hero`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Attack / Item`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Same strats as before, except this is where Clay Guardian is useful.`}</p>
    <h3 {...{
      "id": "rockaxe"
    }}>{`Rockaxe`}</h3>
    <p>{`Pick up Violence Rune`}</p>
    <h3 {...{
      "id": "greenhill-matilda-forest"
    }}>{`Greenhill-Matilda Forest`}</h3>
    <p>{`If no battle yet, can try to use DoReMi elves as backup.`}<br parentName="p"></br>{`
`}{`Elves die to either 3 Shining Light or Rina's Dancing Flames.`}</p>
    <h3 {...{
      "id": "world-map--two-river--lakewest"
    }}>{`World Map > Two River > Lakewest`}</h3>
    <p><strong parentName="p">{`Pick up Kindness Rune`}</strong></p>
    <h3 {...{
      "id": "world-map-3"
    }}>{`World Map`}</h3>
    <p><strong parentName="p">{`Trigger Coronet Skip by entering directly to the left of the dock.`}</strong></p>
    <h3 {...{
      "id": "kuskus"
    }}>{`Kuskus`}</h3>
    <h4 {...{
      "id": "blacksmith-1"
    }}>{`Blacksmith`}</h4>
    <h5 {...{
      "id": "embed"
    }}>{`Embed`}</h5>
    <p>{`Kindness > Nanami`}</p>
    <p>{`To Sharpen Weapon to 4/5/6 after Embed you need 14100/16800/20300 potch`}</p>
    <h3 {...{
      "id": "south-window"
    }}>{`South Window`}</h3>
    <p>{`On entrance `}<em parentName="p">{`Viktor, Eilie`}</em>{` `}<strong parentName="p">{`Option 3`}</strong>{` `}<em parentName="p">{`Viktor, Pilika`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`If Jizo wasn't popped, do this menu when Flik & Viktor join you`}<br parentName="p"></br>{`
`}{`Then for SDS Shift instead of Defend. Without Leather Cape, without Defend you risk dieing to 2 near max roll column attacks.`}</p>
    <h4 {...{
      "id": "equipment-5"
    }}>{`Equipment`}</h4>
    <p>{`Nanami Clay Guardian > Flik Leather Cape`}<br parentName="p"></br>{`
`}{`Nanami Medicine > Hero Jizo`}</p>
    <h4 {...{
      "id": "rune-shop"
    }}>{`Rune Shop`}</h4>
    <h5 {...{
      "id": "buy-1"
    }}>{`Buy`}</h5>
    <p>{`2 Lightning`}<br parentName="p"></br>{`
`}<em parentName="p">{`Note: if only enough money for 1 Lightning don't attach it to Hero`}</em></p>
    <h5 {...{
      "id": "attach"
    }}>{`Attach`}</h5>
    <p>{`Violence > Nanami`}<br parentName="p"></br>{`
`}{`Lightning > Hero Head Slot `}<em parentName="p">{`(Slot is important!)`}</em></p>
    <p>{`Go to inn, `}<strong parentName="p">{`Pick up Friendship Rune`}</strong>{`, go to Town Hall`}<br parentName="p"></br>{`
`}{`When leaving Nanami > Viktor > Cutscene. After textboxes have 38 second break`}<br parentName="p"></br>{`
`}{`Back to inn`}</p>
    <h3 {...{
      "id": "north-window"
    }}>{`North Window`}</h3>
    <p><em parentName="p">{`Nanami runs behind you, Neclord 2 textboxes.`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "cave-of-the-wind"
    }}>{`Cave of the Wind`}</h3>
    <p>{`Pick up Blue Gate & 3000 potch `}<em parentName="p">{`Top two chests`}</em></p>
    <p><em parentName="p">{`Kahn, Viktor sweat animation, Kahn "So may I..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><strong parentName="p">{`Heal Nanami (ONLY NANAMI)`}</strong></p>
    <h4 {...{
      "id": "star-dragon-sword-2500hp"
    }}>{`Star Dragon Sword (2500HP)`}</h4>
    <p><strong parentName="p">{`Turn 1`}</strong><br parentName="p"></br>{`
`}{`Nanami Shift if we equipped Leather Cape, else Defend.`}<br parentName="p"></br>{`
`}{`Freed Shift, Rest Defend`}</p>
    <p><strong parentName="p">{`Turn 2`}</strong><br parentName="p"></br>{`
`}{`Nanami Attack`}</p>
    <h3 {...{
      "id": "wm--north-window"
    }}>{`WM > North Window`}</h3>
    <p><strong parentName="p">{`Heal Nanami`}</strong></p>
    <p>{`If Nanami doesn't have Jizo formation swap Viktor & Nanami`}<br parentName="p"></br>{`
`}<em parentName="p">{`If you forgot to remove Gengen's Wooden Shield can take Freed's`}</em></p>
    <h4 {...{
      "id": "abomination-4500hp"
    }}>{`Abomination (4500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Freed Shift`}</li>
      <li parentName="ul"><strong parentName="li">{`If Nanami has Jizo`}</strong>{` Nanami Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Else`}</strong>{` Nanami Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2--on"
    }}>{`Turn 2 & on`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`If Nanami is Violenced & Berserk`}</strong>{` Nanami attack`}</li>
      <li parentName="ul"><strong parentName="li">{`If Nanami is Violenced but not Berserk`}</strong>{` Hero Bolt Nanami Attack or Family Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Else`}</strong>{`, refer to turn 1 & heal Nanami if damaged.`}</li>
    </ul>
    <h3 {...{
      "id": "castle"
    }}>{`Castle`}</h3>
    <p><em parentName="p">{`Viktor: "But...", Flik, Tsai, Rina: "..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Radat`}</p>
    <h3 {...{
      "id": "radat"
    }}>{`Radat`}</h3>
    <p>{`Tavern after Shu leaves Apple `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Richmond `}<strong parentName="p">{`Option 2`}</strong>{` then Option 1`}</p>
    <p>{`Sluice Gate `}<strong parentName="p">{`Option 2 x3`}</strong></p>
    <h4 {...{
      "id": "amada-duel-1"
    }}>{`Amada Duel #1`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dammit!!! I might lose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Argh! I'll get ya next`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ARGH!!!!.....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Damn! Dammit!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, boy, here`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, first a little`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`He he, first show me`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, it's my turn next!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch!!! I definitely`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I won't fall for that`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Way to go, kid!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-1"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`Option 2`}</strong>{` to lead battle`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "war-battle-4"
    }}>{`War Battle #4`}</h3>
    <p><strong parentName="p">{`Turn 1`}</strong><br parentName="p"></br>{`
`}{`State Soldier Wait`}<br parentName="p"></br>{`
`}{`Hero Repair Self / Bright Shield`}<br parentName="p"></br>{`
`}<em parentName="p">{`You get ~1:40 break here unless a unit with with death dialogue dies`}</em></p>
    <blockquote>
      <p parentName="blockquote">{`This is a new strat. Turns out using Repair Self / Bright Shield triggers the Solon Jhee event`}</p>
    </blockquote>
    <p><strong parentName="p">{`Turn 2 & on`}</strong><br parentName="p"></br>{`
`}{`Move State Soldier out of Solon Jhee's range`}</p>
    <h3 {...{
      "id": "castle-2"
    }}>{`Castle`}</h3>
    <p>{`Go to Bed, Nanami, `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Great Hall`}<br parentName="p"></br>{`
`}{`Name Castle after Eilie talks`}</p>
    <p><em parentName="p">{`Go to Castle entrance`}</em>{` Fitcher `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Great Hall `}<em parentName="p">{`Flik, Fitcher, Flik`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Go to Radat`}</p>
    <h3 {...{
      "id": "radat-1"
    }}>{`Radat`}</h3>
    <p>{`Talk to Amada Option 1 x2`}</p>
    <h3 {...{
      "id": "amada-duel-2"
    }}>{`Amada Duel #2`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dammit!!! I might lose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Argh! I'll get ya next`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ARGH!!!!.....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Damn! Dammit!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, boy, here`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, first a little`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`He he, first show me`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Okay, it's my turn next!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ouch!!! I definitely`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I won't fall for that`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Way to go, kid!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-3"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall`}</p>
    <h4 {...{
      "id": "party-1"
    }}>{`Party`}</h4>
    <p>{`Rina (1D)`}<br parentName="p"></br>{`
`}{`Bolgan (1D)`}<br parentName="p"></br>{`
`}{`Luc (1U)`}</p>
    <h4 {...{
      "id": "formation-4"
    }}>{`Formation`}</h4>
    <p>{`Nanami > Rina`}</p>
    <h3 {...{
      "id": "lakewest"
    }}>{`Lakewest`}</h3>
    <p><strong parentName="p">{`IMPORTANT, go to shop!`}</strong></p>
    <h4 {...{
      "id": "shop-1"
    }}>{`Shop`}</h4>
    <h5 {...{
      "id": "sell"
    }}>{`Sell`}</h5>
    <p>{`Rina Boots`}<br parentName="p"></br>{`
`}<em parentName="p">{`If Jizo was popped & under 16500 potch`}</em><br parentName="p"></br>{`
`}{`Hero Chain Mail`}<br parentName="p"></br>{`
`}{`Luc Circlet`}</p>
    <h5 {...{
      "id": "buy-2"
    }}>{`Buy`}</h5>
    <p>{`3 Escape Talisman`}<br parentName="p"></br>{`
`}{`2-3 Jizo, 3 if yours was popped.`}<br parentName="p"></br>{`
`}<em parentName="p">{`One on Hero, one in bag or on Nanami, one on Nanami`}</em></p>
    <h3 {...{
      "id": "two-river"
    }}>{`Two River`}</h3>
    <blockquote>
      <p parentName="blockquote">{`After Chaco steals wallet go to winger section. Don't need to go to City Hall.`}</p>
    </blockquote>
    <p>{`First Chaco chase, chase him x2 go around Chase him x3 go around and finish Chase. Saves ~2s.`}<br parentName="p"></br>{`
`}{`Ridley and Makai fighting `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Makai asks for help `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "sewer"
    }}>{`Sewer`}</h3>
    <p>{`Pick up Fire Emblem (Top chest)`}</p>
    <h3 {...{
      "id": "pest-rat-5200hp"
    }}>{`Pest Rat (5200HP)`}</h3>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <p>{`Nanami Attack rest Defend`}</p>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`If Violence & Berserk`}</strong>{` : Nanami Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`If Violence & No Berserk`}</strong>{` : Family Attack (or Shredding + Hero Bolt, slower. Or BC if high level Rina)`}</li>
      <li parentName="ul"><strong parentName="li">{`If Jizo popped & no Violence`}</strong>{` : Luc Mega Medicine Nanami, Nanami Defend`}</li>
      <li parentName="ul"><strong parentName="li">{`If Nanami Damaged & no Violence`}</strong>{` : Luc Mega Medicine Nanami, Nanami Defend`}</li>
      <li parentName="ul"><strong parentName="li">{`If Nanami not hit`}</strong>{` : Nanami Attack`}</li>
    </ul>
    <h3 {...{
      "id": "two-river-1"
    }}>{`Two River`}</h3>
    <p>{`Reinforcements `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`After Battle Option 2`}</strong>{` then Option 1, `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "lakewest--castle"
    }}>{`Lakewest > Castle`}</h3>
    <h4 {...{
      "id": "party-2"
    }}>{`Party`}</h4>
    <p>{`Eilie (X)`}<br parentName="p"></br>{`
`}{`Luc (2U)`}</p>
    <h5 {...{
      "id": "formation-5"
    }}>{`Formation`}</h5>
    <p>{`Nanami > Luc `}<em parentName="p">{`OR Hero > Nanami if Jizo was popped`}</em></p>
    <blockquote>
      <p parentName="blockquote">{`The Formation swap doesn't cost any time & speeds up the equipment menu a bit`}</p>
    </blockquote>
    <h4 {...{
      "id": "equipment-6"
    }}>{`Equipment`}</h4>
    <p><strong parentName="p">{`Hero`}</strong><br parentName="p"></br>{`
`}{`Best Equip`}</p>
    <p><strong parentName="p">{`Flik`}</strong><br parentName="p"></br>{`
`}{`Equip Feathered Hat`}<br parentName="p"></br>{`
`}{`Mega Medicine > Jizo `}<strong parentName="p">{`from bag`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Optional`}</em>{` Can swap another accessory for Nanami's Jizo`}</p>
    <h3 {...{
      "id": "lakewest--world-map--greenhill"
    }}>{`Lakewest > World Map > Greenhill`}</h3>
    <p>{`Pick names after Fitcher leaves & Flik talks`}<br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Bedtime `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><strong parentName="p">{`First 2 Battles`}</strong><br parentName="p"></br>{`
`}{`Shining Light`}</p>
    <h4 {...{
      "id": "rune-shop-1"
    }}>{`Rune Shop`}</h4>
    <h5 {...{
      "id": "buy-3"
    }}>{`Buy`}</h5>
    <p>{`Kite`}</p>
    <h5 {...{
      "id": "attach-1"
    }}>{`Attach`}</h5>
    <p>{`Lightning > Luc `}<em parentName="p">{`over Wind`}</em><br parentName="p"></br>{`
`}{`Wind > Hero `}<em parentName="p">{`Left Hand`}</em><br parentName="p"></br>{`
`}{`Blue Gate > Luc`}<br parentName="p"></br>{`
`}{`Kite > Eilie`}<br parentName="p"></br>{`
`}{`Spark > Nanami `}<em parentName="p">{`over Violence`}</em><br parentName="p"></br>{`
`}{`Violence > Eilie`}</p>
    <h4 {...{
      "id": "blacksmith-2"
    }}>{`Blacksmith`}</h4>
    <h5 {...{
      "id": "embed-1"
    }}>{`Embed`}</h5>
    <p>{`Poison > Nanami`}<br parentName="p"></br>{`
`}{`Friendship > Hero `}<em parentName="p">{`Unless Kyaro soldiers dropped a Hazy Crystal`}</em><br parentName="p"></br>{`
`}{`Kindness > Eilie`}</p>
    <h5 {...{
      "id": "sharpen"
    }}>{`Sharpen`}</h5>
    <p>{`Hero > lvl 8`}</p>
    <p><strong parentName="p">{`Next 6 Battles`}</strong><br parentName="p"></br>{`
`}{`Eilie Kite Rune`}<br parentName="p"></br>{`
`}<em parentName="p">{`Watch Flik MGC, needs to be 100 at 33`}</em></p>
    <h3 {...{
      "id": "castle-4"
    }}>{`Castle`}</h3>
    <p>{`Go back to bed`}</p>
    <h4 {...{
      "id": "party-3"
    }}>{`Party`}</h4>
    <p>{`Rina (1U)`}<br parentName="p"></br>{`
`}{`Bolgan (1U)`}<br parentName="p"></br>{`
`}<em parentName="p">{`OPTIONAL: Flik (X) (extra Luca safety if 1 Jizo and/or extra levels if < 100 MGC)`}</em><br parentName="p"></br>{`
`}{`Nanami (3/2 D)`}</p>
    <h3 {...{
      "id": "lakewest--two-river--greenhill-matilda-border"
    }}>{`Lakewest > Two River > Greenhill-Matilda Border`}</h3>
    <p>{`Viki Option 1 `}<strong parentName="p"><em parentName="strong">{`then Option 2`}</em></strong></p>
    <h3 {...{
      "id": "rockaxe-1"
    }}>{`Rockaxe`}</h3>
    <p>{`Camus refugee battle `}<strong parentName="p"><em parentName="strong">{`Option 3`}</em></strong></p>
    <h3 {...{
      "id": "muse-matilda-border"
    }}>{`Muse-Matilda Border`}</h3>
    <p>{`Miklotov `}<strong parentName="p">{`Option 2`}</strong>{`, to Convoy`}</p>
    <h3 {...{
      "id": "muse-5"
    }}>{`Muse`}</h3>
    <p>{`Miklotov 2 textboxes then ~50 second cutscene break.`}</p>
    <h5 {...{
      "id": "soldier-fight"
    }}>{`Soldier fight`}</h5>
    <p><strong parentName="p">{`Rina Take from Bag Mega Medicine`}</strong><br parentName="p"></br>{`
`}{`Hero Shining Light / Shredding`}<br parentName="p"></br>{`
`}<em parentName="p">{`Hero needs 122MGC for Shining Light to kill. ~LVL49`}</em></p>
    <h3 {...{
      "id": "castle-5"
    }}>{`Castle`}</h3>
    <p>{`Great Hall > Go to bed > Great Hall`}<br parentName="p"></br>{`
`}{`Teleport to Radat (2D)`}</p>
    <h3 {...{
      "id": "radat-2"
    }}>{`Radat`}</h3>
    <p>{`Option 1`}<br parentName="p"></br>{`
`}{`Re-enter Radat, `}<strong parentName="p">{`Option 2`}</strong></p>
    <h1 {...{
      "id": "head-to-south-window-to-recruit-adlai"
    }}>{`Head to South Window to Recruit Adlai!!!`}</h1>
    <h3 {...{
      "id": "south-window-1"
    }}>{`South Window`}</h3>
    <p><em parentName="p">{`If only you only bought 1 Lightning before, go to Rune shop & buy and attach to`}<br parentName="em"></br>
        {`Hero's Head`}</em></p>
    <p>{`Recruit Adlai`}</p>
    <h3 {...{
      "id": "castle-6"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "war-battle"
    }}>{`War Battle`}</h3>
    <p><em parentName="p">{`Try to keep an eye on where Adlai, Chaco, and Camus are.`}</em></p>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <p>{`Hero 1U`}<br parentName="p"></br>{`
`}{`Viktor (R1) 2L`}<br parentName="p"></br>{`
`}{`Kobold (R2) 1U`}<br parentName="p"></br>{`
`}{`Kobold (R2) 1U`}<br parentName="p"></br>{`
`}{`Gilbert (R2) 1L`}<br parentName="p"></br>{`
`}{`Ridley (R2) Wait`}<br parentName="p"></br>{`
`}{`Luc (R2) 1L`}<br parentName="p"></br>{`
`}{`Teresa (R2) 1L`}<br parentName="p"></br>{`
`}{`Flik (R2) 2L`}</p>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <p>{`Hero 1U`}<br parentName="p"></br>{`
`}{`Viktor (R1) 2L`}<br parentName="p"></br>{`
`}{`Flik (R1) 2U`}<br parentName="p"></br>{`
`}{`Teresa (R1) 2/1U`}<br parentName="p"></br>{`
`}{`Luc (R1) 1L`}</p>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <p>{`End Turn`}</p>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <p><em parentName="p">{`If in Enemy Attack Range`}</em><br parentName="p"></br>{`
`}{`Gilbert (R2) 1L`}<br parentName="p"></br>{`
`}{`Teresa (Manual or 2R2) 1U`}</p>
    <h3 {...{
      "id": "castle-7"
    }}>{`Castle`}</h3>
    <p><strong parentName="p">{`After War Battle`}</strong>{` Talk to Apple (can move between Viktor and Flik)`}</p>
    <h4 {...{
      "id": "army-formation-depends-on-strat"
    }}>{`Army Formation (Depends on strat)`}</h4>
    <h5 {...{
      "id": "standard-kiba-strat"
    }}>{`Standard Kiba Strat`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Viktor`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Flik`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Luc`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Miklotov`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tsai`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Camus`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Adlai`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Chaco`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "alternate-kiba-strat"
    }}>{`Alternate Kiba Strat`}</h5>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Viktor`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Hero`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Miklotov`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Camus`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Adlai`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Chaco`}</strong></td>
        </tr>
      </tbody>
    </table>
    <p>{`Go to bed`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "kiba-war-battle"
    }}>{`Kiba War Battle`}</h3>
    <h4 {...{
      "id": "standard-strat"
    }}>{`Standard Strat`}</h4>
    <h5 {...{
      "id": "turns-1-5"
    }}>{`Turns 1-5`}</h5>
    <p>{`Move 3R1U`}</p>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <p>{`Luc Wind Magic`}<br parentName="p"></br>{`
`}{`Flik Fire Spear (If Luc failed)`}<br parentName="p"></br>{`
`}{`Gilbert DR`}</p>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <p>{`Hero`}<br parentName="p"></br>{`
`}{`Gilbert 2R`}<br parentName="p"></br>{`
`}{`Luc Wind Magic (If Kiba < 2 damage)`}<br parentName="p"></br>{`
`}{`Flik Fire Spear (If Kiba < 2 damage)`}</p>
    <h5 {...{
      "id": "turn-8--on"
    }}>{`Turn 8 & on`}</h5>
    <p>{`Use Judgement`}</p>
    <h4 {...{
      "id": "alternate-strat"
    }}>{`Alternate Strat`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Can use `}<a parentName="p" {...{
          "href": "https://www.youtube.com/watch?v=_1a6RA_gIds"
        }}>{`this video`}</a>{` as a reference.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`So this strat revolves around pulling Kiba's army away from your main army's position. With Chaco & Camus, we have enough defense that Rowd's army will never attack Hero & Kiba's army will tend to not attack you in melee range.`}<br parentName="p"></br>{`
`}{`First 3 turns are always the same, afterwards you might have to adjust Hero's movement based on enemy unit positions.`}<br parentName="p"></br>{`
`}{`Turn 4 you probably want to move as far right as possible without getting in range of an enemy unit.`}<br parentName="p"></br>{`
`}{`Turn 5 you'll probably need to move left & down to pull the soldiers furthest to the top left towards you instead of Viktor.`}<br parentName="p"></br>{`
`}{`Turn 6 you want to move Viktor, Flik, Teresa away & move Hero towards the top right side. Make sure that the soldier's to the left are closer to Hero than they are to Viktor.`}<br parentName="p"></br>{`
`}{`Turn 7 move Hero towards the top right, preferably into a chokepoint that minimizes attacks. Move Viktor, Flik, Teresa away a bit more.`}<br parentName="p"></br>{`
`}{`Turn 8 & on just move Kobolds away and minimize attacks on Hero.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`This strat by my estimate is approximately 1 minute slower than killing Kiba. There is variance, it depends on how many attacks there are during the battle. If you're going for WR standard Kiba makes more sense. If you're trying to improve, PB, or just practice I think this strat is better because of how much more consistent it is.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <p>{`Hero 2R1D`}</p>
    <h5 {...{
      "id": "turn-23"
    }}>{`Turn 2&3`}</h5>
    <p>{`Hero 2R`}</p>
    <h5 {...{
      "id": "turn-4on"
    }}>{`Turn 4&on`}</h5>
    <p>{`Use Hero to pull Kiba's army to the right, move rest of army away from Kiba's army.`}</p>
    <p>{`Kiba Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "castle-8"
    }}>{`Castle`}</h3>
    <p>{`Trigger Sheena, then go to Tavern`}</p>
    <blockquote>
      <p parentName="blockquote">{`Using Viki to teleport to Castle saves .2s but can fail teleport.`}</p>
    </blockquote>
    <h4 {...{
      "id": "party-4"
    }}>{`Party`}</h4>
    <p>{`Eilie `}<strong parentName="p">{`1U`}</strong><br parentName="p"></br>{`
`}{`Viki `}<strong parentName="p">{`2D`}</strong><br parentName="p"></br>{`
`}{`Luc `}<strong parentName="p">{`1L1D`}</strong></p>
    <p>{`Sheena form an alliance `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Teleport to Radat (5D)`}</p>
    <h3 {...{
      "id": "radat--banner-village--banner-pass"
    }}>{`Radat > Banner Village > Banner Pass`}</h3>
    <h4 {...{
      "id": "worm-4200hp"
    }}>{`Worm (4200HP)`}</h4>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Eilie Attack / Shift`}</li>
      <li parentName="ul">{`Freed Shift / Defend (We need Freed to die here)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`If Lightning and Eilie Violenced`}</strong>{` Auto`}</li>
      <li parentName="ul"><strong parentName="li">{`If Lightning and Eilie not Violenced`}</strong>{` All Defend`}</li>
      <li parentName="ul"><strong parentName="li">{`If Slam attack`}</strong>{` Eilie Shift/Attack rest Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Auto`}</li>
    </ul>
    <p>{`On final screen (screen after screen after Worm) `}<strong parentName="p">{`Escape Talisman`}</strong></p>
    <h3 {...{
      "id": "gregminster"
    }}>{`Gregminster`}</h3>
    <p><strong parentName="p"><em parentName="strong">{`When Sheena asks which girl Option 2 to get Kasumi`}</em></strong></p>
    <p><strong parentName="p">{`You can setup Rune Unite SPD Glitch anytime between now & the Luca Fight.`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Toss Bandana & Robe to trigger RU Speed Glitch`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`If you got a Hazy Crystal from Kyaro Soldiers & equipped Friendship toss all Gloves in inventory as well.`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <p>{`Kasumi to Party`}</p>
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <p>{`Toss Bandana, Robe, Gloves if needed`}</p>
      <h5 {...{
        "id": "kasumi"
      }}>{`Kasumi`}</h5>
      <ul>
        <li parentName="ul">{`Remove Circuret`}</li>
        <li parentName="ul">{`Remove Ninja Suit`}</li>
        <li parentName="ul">{`Swap Speed Ring > Medicine`}</li>
        <li parentName="ul">{`Swap Medicine > Hero's Jizo`}</li>
        <li parentName="ul">{`Remove Winged Boots`}</li>
        <li parentName="ul"><strong parentName="li">{`Make sure you keep Bolt of Wrath on her`}</strong></li>
      </ul>
      <h5 {...{
        "id": "eilie"
      }}>{`Eilie`}</h5>
      <ul>
        <li parentName="ul">{`Best Equip x2`}</li>
        <li parentName="ul"><em parentName="li">{`Make sure she has all SPD stuff, fill last slot with Bolt or +DEF accessory`}</em></li>
      </ul>
      <h5 {...{
        "id": "luc"
      }}>{`Luc`}</h5>
      <ul>
        <li parentName="ul">{`Any Accessory > Viki's Magic Ring`}</li>
        <li parentName="ul">{`Remove other Accessory`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`With Circuret, Ninja Suit, Winged Boots, Speed Ring, and average stats, Eilie survives a max roll Bite attack from Bone Dragon with 4HP remaining. You can give her an extra accessory or a Head Gear if Greenhill Soldiers dropped one to make it safer. If you don't want to risk going for the Bite attack, there's no reason to equip the Circuret.`}</p>
    </blockquote>
    <h3 {...{
      "id": "castle-9"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Don't exit & Blinking Mirror. This will make your castle upgrade early.`}</p>
    </blockquote>
    <p>{`Meeting Room > Talk to Nanami`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "ridley-capture-war-battle"
    }}>{`Ridley Capture War Battle`}</h3>
    <p><strong parentName="p">{`Turn 1`}</strong><br parentName="p"></br>{`
`}{`Ridley 1R Attack unit above him (automatically selected)`}</p>
    <p><strong parentName="p">{`Turn 2 & on`}</strong><br parentName="p"></br>{`
`}{`Flik Fire Spear Hero `}<em parentName="p">{`Flik is to the right of Hero`}</em><br parentName="p"></br>{`
`}{`Viktor / Gilbert Adlai Hero `}<em parentName="p">{`Viktor is below Hero, Gilbert is bottom right of Hero`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`To select Ridley R2 from Gilbert(Kiba if no Gilbert) / R1 from Luc`}</em><br parentName="p"></br>{`
`}{`Ridley Attack strongest unit`}</p>
    <h3 {...{
      "id": "army-formation"
    }}>{`Army Formation`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Viktor`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Flik`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Kasumi`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Shu`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tsai`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Miklotov`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Klaus`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Chaco`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Adlai`}</strong></td>
        </tr>
      </tbody>
    </table>
    <p>{`Go to bed Tsai `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "luca-war-battle"
    }}>{`Luca War Battle`}</h3>
    <p><strong parentName="p">{`Turn 1`}</strong><br parentName="p"></br>{`
`}{`Flik (2 * R1) Fire Spear Luca`}<br parentName="p"></br>{`
`}{`Kasumi Invention`}</p>
    <p><strong parentName="p">{`Turn 2`}</strong><br parentName="p"></br>{`
`}{`Flik (2 * R1) Fire Spear Luca`}</p>
    <h3 {...{
      "id": "castle-10"
    }}>{`Castle`}</h3>
    <p><strong parentName="p"><em parentName="strong">{`!!!!! IMPORTANT !!!!!`}</em></strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Toss Bandana & Robe to trigger RU Speed Glitch`}</strong><br parentName="p"></br>{`
`}<strong parentName="p"><em parentName="strong">{`!!!!! IMPORTANT !!!!!`}</em></strong></p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "http://www.suikosource.com/phpBB3/viewtopic.php?f=9&t=12441&start=650"
        }}>{`Rune Unite Speed Glitch Explanation on Suikosource.`}</a></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`The Rune Unite Speed Glitch gives a 1.3 speed multiplier to certain Rune Unites.`}<br parentName="p"></br>{`
`}{`It's the same modifer that healing spells, healing items, and Empty World get.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you want to get a better idea of how it works I recommend reading the link above. For the speedrun, we take advantage of the fact that Flaming Arrows Scroll, Bandanna, and Robe take up 3 adjacent early slots in the inventory heap. When we use the Flaming Arrow scroll on Kyaro Soldiers, we open up that slot and it gets filled by Jowy's Tunic when he rejoins your party. Then, when we get Bright Shield, he leaves your party again & removes Tunic from the heap. And it's slot is replaced by the Bright Shield we get at that point. That's why a Hazy Crystal drop affects the setup, if we get that it fills the Tunic's slot instead of Bright Shield.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`We purposely keep Bandanna & Robe in our inventory to keep those slots occupied, essentially using them as placeholders. Before we start the Luca sequence, we toss all our Bandanna's & Robe's to open up those slots.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`The Luca sequence has a unique property where Hero & his equipment and runes are removed from the heap. Unless we got Hazy drop, we now have 3 open slots near the start of the item heap. When Hero rejoins & his items are readded, the first things loaded into the heap are his runes. It goes Weapon, Head, Right, Left, then armor. The goal is to have Bright Shield loaded in the slot after Lightning, this sets up the glitch. Since we have 3 slots available, the list will go: Friendship, Lightning, Bright Shield, which sets up the glitch. This is also why we skip equipping Friendship if we got the Hazy Crystal drop: we can't guarantee that we have the first of 3 slots open anymore. So we leave 2 open & have Lightning & Bright Shield loaded into them.`}</p>
    </blockquote>
    <p>{`1st Floor to trigger scene (Run close to Luc before going down to save ~1s)`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Option 2`}</strong>{` to kick Luca's ass`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "hero"
      }}>{`Hero`}</h5>
      <p>{`Skip`}</p>
      <h5 {...{
        "id": "flik"
      }}>{`Flik`}</h5>
      <ul>
        <li parentName="ul">{`Luc `}<strong parentName="li">{`1L2D`}</strong></li>
        <li parentName="ul">{`Kasumi `}<strong parentName="li">{`1U`}</strong>{` OR Miklotov if Eilie using Bolt`}</li>
        <li parentName="ul">{`Rina `}<strong parentName="li">{`1R1U`}</strong></li>
        <li parentName="ul">{`Bolgan `}<strong parentName="li">{`1U`}</strong></li>
        <li parentName="ul">{`Eilie `}<strong parentName="li">{`2U`}</strong></li>
      </ul>
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <p>{`Flik > Bolgan`}</p>
      <h5 {...{
        "id": "viktor"
      }}>{`Viktor`}</h5>
      <p>{`Skip`}</p>
    </Menu>
    <p>{`After party selection `}<em parentName="p">{`Shu talks`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "luca-flik-party"
    }}>{`Luca Flik Party`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 1`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 2`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bolgan: Circus Attack`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Luc: Empty World`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`If Eilie Defended / Missed`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Kasumi: Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Kasumi: Bolt of Wrath`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Mega Medicine Bolgan`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Flik: Thor Shot`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Attack / Defend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "luca-viktor"
    }}>{`Luca Viktor`}</h4>
    <p>{`Auto`}</p>
    <h4 {...{
      "id": "luca-hero"
    }}>{`Luca Hero`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`If Eilie missed / Defended`}</strong>{` Thor Shot`}</li>
      <li parentName="ul"><strong parentName="li">{`If Eilie attack hit`}</strong>{` Auto`}</li>
    </ul>
    <p><strong parentName="p">{`2 Whitewolves Battles`}</strong><br parentName="p"></br>{`
`}{`Hero Shredding`}</p>
    <p>{`Luca has 164SPD, heal if low & he's faster.`}</p>
    <h4 {...{
      "id": "luca-duel-135hp"
    }}>{`Luca Duel (135HP)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Fool!!! That can't`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pig!!!! Die!!!!!!!!`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`That's nothing!`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Ridiculous!!! You think`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pig!!!!! You dare to`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You impertinent little`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You little punk...`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You little punk!!!`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "castle-11"
    }}>{`Castle`}</h3>
    <p>{`Go to 1st floor, run close to Luc before going down to save 1s`}<br parentName="p"></br>{`
`}{`Teleport to Kuskus (3D)`}</p>
    <h3 {...{
      "id": "kuskus-1"
    }}>{`Kuskus`}</h3>
    <p>{`After Culgan leave by boat and Blinking Mirror`}</p>
    <h3 {...{
      "id": "castle-12"
    }}>{`Castle`}</h3>
    <p><em parentName="p">{`Teresa talks`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "party-6"
    }}>{`Party`}</h4>
    <p>{`Rina (2U)`}<br parentName="p"></br>{`
`}{`Eilie (3D)`}<br parentName="p"></br>{`
`}{`Luc (1R1U)`}</p>
    <h3 {...{
      "id": "muse-6"
    }}>{`Muse`}</h3>
    <p>{`After archers Jowy `}<strong parentName="p">{`Option 2`}</strong></p>
    <h4 {...{
      "id": "party-7"
    }}>{`Party`}</h4>
    <p><strong parentName="p">{`Viktor > Party`}</strong></p>
    <p><strong parentName="p">{`6 Soldiers`}</strong><br parentName="p"></br>{`
`}{`Eilie Kite Rune`}</p>
    <p><em parentName="p">{`After Battle run to right wall, walk 1 step down, then run down. If done properly should skip battle at stairs. Walking exactly 1 step is necessary.`}</em></p>
    <h3 {...{
      "id": "castle-13"
    }}>{`Castle`}</h3>
    <p>{`Leave Castle then Blinking Mirror`}<br parentName="p"></br>{`
`}{`Trigger Shu cutscene`}<br parentName="p"></br>{`
`}{`Teleport to Castle (1R1U)`}</p>
    <p>{`Run left to wall then up to trigger Koyu, `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`Viktor `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Koyu to convoy`}<br parentName="p"></br>{`
`}{`Nanami `}<strong parentName="p">{`Option 2`}</strong></p>
    <p>{`Teleport to Two River (3U)`}</p>
    <h3 {...{
      "id": "two-river--drakemouth"
    }}>{`Two River > Drakemouth`}</h3>
    <p>{`Gijimu Cutscene then run to Tigermouth`}</p>
    <h3 {...{
      "id": "tigermouth--tinto"
    }}>{`Tigermouth > Tinto`}</h3>
    <p>{`Pick up Power Ring`}<br parentName="p"></br>{`
`}{`All dialogue options Option 1`}</p>
    <p>{`After the second time going to bed go to Nanami's room instead of your room.`}</p>
    <h3 {...{
      "id": "neclord-fight"
    }}>{`Neclord Fight`}</h3>
    <p><strong parentName="p">{`Turns 1-3`}</strong><br parentName="p"></br>{`
`}{`Defend`}</p>
    <p>{`After Cutscene `}<strong parentName="p">{`Escape Talisman`}</strong></p>
    <h3 {...{
      "id": "crom"
    }}>{`Crom`}</h3>
    <h4 {...{
      "id": "party-8"
    }}>{`Party`}</h4>
    <p>{`Sheena `}<strong parentName="p">{`1D`}</strong><br parentName="p"></br>{`
`}{`Eilie `}<strong parentName="p">{`2D`}</strong><br parentName="p"></br>{`
`}{`Luc `}<strong parentName="p">{`1R1U`}</strong></p>
    <h4 {...{
      "id": "formation-7"
    }}>{`Formation`}</h4>
    <p>{`Hero > Eilie`}</p>
    <p>{`Kahn scene put `}<strong parentName="p">{`Kahn in convoy`}</strong><br parentName="p"></br>{`
`}{`Teleport to Tigermouth `}<strong parentName="p">{`1R2U`}</strong></p>
    <h3 {...{
      "id": "tigermouth"
    }}>{`Tigermouth`}</h3>
    <p><strong parentName="p">{`Sierra Skip`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Line up with bottom of wall to the left of Sierra.`}<br parentName="p"></br>{`
`}{`Run right until you bounce up off corner on top of right wall.`}<br parentName="p"></br>{`
`}{`Run up and talk to Sierra.`}</p>
    </blockquote>
    <h4 {...{
      "id": "sierra-2800hp"
    }}>{`Sierra (2800HP)`}</h4>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Eilie Attack`}</li>
      <li parentName="ul">{`Hero Attack`}</li>
      <li parentName="ul">{`Luc Empty World`}</li>
    </ul>
    <p>{`Teleport to Crom `}<strong parentName="p">{`1R3D`}</strong></p>
    <h3 {...{
      "id": "crom-1"
    }}>{`Crom`}</h3>
    <h4 {...{
      "id": "party-9"
    }}>{`Party`}</h4>
    <p>{`Nanami > Convoy`}<br parentName="p"></br>{`
`}{`Kahn > Party`}<br parentName="p"></br>{`
`}{`Sierra > Convoy`}</p>
    <p>{`Leave Crom through top left path`}</p>
    <h3 {...{
      "id": "tinto-mines"
    }}>{`Tinto Mines`}</h3>
    <p>{`Pick up Master Garb`}</p>
    <blockquote>
      <p parentName="blockquote">{`Double-Strike is no longer needed, skip it`}</p>
    </blockquote>
    <p>{`Before Golem `}<strong parentName="p">{`Heal Eilie`}</strong>{` & party using Rune or items if you haven't already`}</p>
    <h4 {...{
      "id": "golem-7500hp"
    }}>{`Golem "7500HP"`}</h4>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Hero Attack / Thor Shot`}</li>
      <li parentName="ul">{`Eilie Attack`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Hero Attack lets you skip Thor Shot T2 if Eilie Crits.`}<br parentName="p"></br>{`
`}{`Hero Thor Shot let's you Auto T2.`}<br parentName="p"></br>{`
`}{`The decision is mostly preference.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`If Violenced`}</strong>{` Eilie Attack, Hero Thor Shot / Auto`}</li>
      <li parentName="ul"><strong parentName="li">{`Else`}</strong>{` All Defend`}</li>
    </ul>
    <h4 {...{
      "id": "item-menu"
    }}>{`Item Menu`}</h4>
    <p>{`Use Kindness Drops scroll to heal Eilie, Sheena, Hero, and whoever else needs a heal.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Escape Talisman`}</strong>{` & run to Tinto`}</p>
    <h3 {...{
      "id": "tinto"
    }}>{`Tinto`}</h3>
    <p>{`Zombie skip`}</p>
    <blockquote>
      <p parentName="blockquote">{`TODO: Zombie Skip instructions`}</p>
    </blockquote>
    <h5 {...{
      "id": "23-zombie-fights"
    }}>{`2/3 Zombie Fights`}</h5>
    <p>{`Eilie Kite Rune`}</p>
    <p><em parentName="p">{`Elevator Path has 2 fights, normal path has 3. With Kite Rune, normal path is about 3s slower.`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`3 Fights gets Eilie to L45 for Neclord, which helps with accuracy & let's you survive a high roll Dark & Lightning attack combo.`}</em></p>
    <p>{`Heal if you haven't already.`}</p>
    <h4 {...{
      "id": "neclord-4500hp"
    }}>{`Neclord (4500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Eilie Attack`}</li>
      <li parentName="ul">{`Rest Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <p>{`Auto`}</p>
    <h4 {...{
      "id": "blacksmith-3"
    }}>{`Blacksmith`}</h4>
    <h5 {...{
      "id": "sharpen-1"
    }}>{`Sharpen`}</h5>
    <p>{`Hero > L13`}</p>
    <h5 {...{
      "id": "embed-2"
    }}>{`Embed`}</h5>
    <p>{`Friendship > Hero, if you haven't already.`}</p>
    <p>{`Jess Option 1 `}<strong parentName="p"><em parentName="strong">{`then Option 2 (I won't fight together.)`}</em></strong><br parentName="p"></br>{`
`}{`Teleport to Castle.`}</p>
    <h3 {...{
      "id": "castle-14"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}<br parentName="p"></br>{`
`}{`Go to bed (3rd floor).`}<br parentName="p"></br>{`
`}{`Take the elevator to the 2nd floor & go to stairs to trigger the cutscene with Chaco.`}<br parentName="p"></br>{`
`}{`Go back to bed.`}</p>
    <h4 {...{
      "id": "lucia-1500hp"
    }}>{`Lucia (1500HP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Battle automatically ends after 5 turns. Faster to win with Lightning though.`}<br parentName="p"></br>{`
`}{`Even if you counter T1, an attack won't do enough damage to kill T2.`}</p>
    </blockquote>
    <p>{`Thor Shot + Bolt of Wrath`}</p>
    <p>{`Option 1 then `}<strong parentName="p">{`Option 2`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Option 1 here is incredibly important. It decides which battle you do.`}<br parentName="p"></br>{`
`}{`Greenhill battle is practically undoable.`}<br parentName="p"></br>{`
`}{`Waiting in Castle is slower than battle at border.`}</p>
    </blockquote>
    <p>{`Meeting Room `}<strong parentName="p">{`Option 2`}</strong>{` then Option 1`}</p>
    <h3 {...{
      "id": "greenhill-liberation-war-battle"
    }}>{`Greenhill Liberation War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <p>{`Hero 1D`}<br parentName="p"></br>{`
`}{`Hauser (R1) 2L`}<br parentName="p"></br>{`
`}{`Teresa (R1) 1U`}<br parentName="p"></br>{`
`}{`Viktor (R1) 2L`}<br parentName="p"></br>{`
`}{`Gilbert (R1) 1D`}</p>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <p>{`Hero 1D`}<br parentName="p"></br>{`
`}{`Hauser (R1) 1L1D`}<br parentName="p"></br>{`
`}{`Teresa (R1) 1U`}<br parentName="p"></br>{`
`}{`Viktor (R1) 2L`}<br parentName="p"></br>{`
`}{`Gilbert (R1) 1D`}<br parentName="p"></br>{`
`}{`Flik (R1) 2L`}</p>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <p>{`Flik (R2) 2L`}</p>
    <h5 {...{
      "id": "turn-4--on"
    }}>{`Turn 4 & on`}</h5>
    <p><em parentName="p">{`If an enemy unit will get in attacking range move away. Shouldn't happen though`}</em><br parentName="p"></br>{`
`}{`End Turn`}</p>
    <h3 {...{
      "id": "greenhill"
    }}>{`Greenhill`}</h3>
    <p><em parentName="p">{`When Shin asks to come along.`}</em>{` `}<strong parentName="p">{`Option 2`}</strong><br parentName="p"></br>{`
`}{`When Teresa joins `}<strong parentName="p">{`don't change formation.`}</strong></p>
    <p><em parentName="p">{`Take a look at Lo Wen's MGC during menu, to see if we want to take her to Muse`}</em></p>
    <h4 {...{
      "id": "party-10"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Flik `}<strong parentName="li">{`X`}</strong></li>
      <li parentName="ul">{`Eilie `}<strong parentName="li">{`1U`}</strong></li>
      <li parentName="ul">{`Rina `}<strong parentName="li">{`1U`}</strong></li>
      <li parentName="ul">{`Bolgan `}<strong parentName="li">{`1U`}</strong></li>
      <li parentName="ul"><em parentName="li">{`Check Lo Wen MGC `}<strong parentName="em">{`1L2D`}</strong>{` then `}<strong parentName="em">{`2U`}</strong>{` for Gijimu`}</em></li>
      <li parentName="ul">{`Gijimu `}<strong parentName="li">{`1L`}</strong></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`This table shows the probability of Lo Wen having 100MGC based off her starting MGC and what level you get her to. To get her to 59 you replace Gijimu with Lo Wen for the Golden Wolf fight.`}</p>
    </blockquote>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "right"
          }}></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`80`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`81`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`82`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`83`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`84`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`85`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`86`}</strong></th>
          <th parentName="tr" {...{
            "align": "right"
          }}><strong parentName="th">{`87`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "right"
          }}><strong parentName="td">{`LVL58`}</strong></td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`5.73%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`15.82%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`33.47%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`56.18%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`77.46%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`91.65%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`98.04%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`99.78%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "right"
          }}><strong parentName="td">{`LVL59`}</strong></td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`22.88%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`42.56%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`64.69%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`83.14%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`94.20%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`98.73%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`99.86%`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`100%`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "formation-8"
    }}>{`Formation`}</h5>
    <p>{`Hero > Rina`}</p>
    <h5 {...{
      "id": "5-soldier-fights"
    }}>{`5 Soldier Fights`}</h5>
    <p>{`Eilie Kite Rune`}</p>
    <blockquote>
      <p parentName="blockquote">{`Skip 6th Soldier battle by running right and down, around the loading zone.`}</p>
    </blockquote>
    <h4 {...{
      "id": "lucia-2-4700hp"
    }}>{`Lucia 2 (4700HP)`}</h4>
    <ul>
      <li parentName="ul">{`Rina Explosion`}</li>
      <li parentName="ul">{`Eilie Attack Lucia`}</li>
      <li parentName="ul">{`Hero Thor Shot Lucia`}</li>
      <li parentName="ul">{`Flik Thor Shot Lucia`}</li>
    </ul>
    <p><em parentName="p">{`If Rina and/or Bolgan are low HP heal with NPC`}</em></p>
    <h4 {...{
      "id": "bone-dragon-8900hp"
    }}>{`Bone Dragon (8900HP)`}</h4>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <p>{`Eilie Shift / Attack`}<br parentName="p"></br>{`
`}{`Rest Defend`}</p>
    <h5 {...{
      "id": "turn-2--on-1"
    }}>{`Turn 2 & on`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`If Violenced`}</strong>{` Rina Circus Attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Else`}</strong>{` Eilie Attack, if needed heal with Gijimu.`}</li>
    </ul>
    <h3 {...{
      "id": "castle-15"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Option 2 is faster than Option 3.`}</p>
    </blockquote>
    <p><em parentName="p">{`Shu: "......" > Apple: "Hero, Jowy, ..." "Most of the..."`}</em>{` `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "greenhill-1"
    }}>{`Greenhill`}</h3>
    <h4 {...{
      "id": "rune-shop-2"
    }}>{`Rune Shop`}</h4>
    <p><em parentName="p">{`Take note of how much money you have here.`}</em></p>
    <h5 {...{
      "id": "remove"
    }}>{`Remove`}</h5>
    <p>{`Gijimu > Double-Beat`}</p>
    <h5 {...{
      "id": "attach-2"
    }}>{`Attach`}</h5>
    <p>{`Double-Beat > Eilie `}<em parentName="p">{`over Violence`}</em></p>
    <blockquote>
      <p parentName="blockquote">{`On first forest screen, where Lucia is running up, don't load the next screen before her. You can skip loading the Jowy cutscene by going too fast.`}</p>
    </blockquote>
    <h3 {...{
      "id": "muse-liberation-war-battle"
    }}>{`Muse Liberation War Battle`}</h3>
    <p><em parentName="p">{`Flik R1x1 from Hauser (1 above Flik starting position)`}</em></p>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <p>{`Kiba 2R`}<br parentName="p"></br>{`
`}{`Flik 3R`}</p>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <p>{`Kiba 2L`}<br parentName="p"></br>{`
`}{`Flik 3R`}</p>
    <h5 {...{
      "id": "turn-3--4"
    }}>{`Turn 3 & 4`}</h5>
    <p>{`Flik runs to Muse`}</p>
    <h3 {...{
      "id": "muse-7"
    }}>{`Muse`}</h3>
    <p>{`Viktor `}<strong parentName="p">{`to convoy`}</strong>{` say `}<strong parentName="p">{`no to change formation.`}</strong></p>
    <h4 {...{
      "id": "party-11"
    }}>{`Party`}</h4>
    <p><em parentName="p">{`If Lo Wen MGC is bad, swap her and Gijimu (1L1D)`}</em></p>
    <h5 {...{
      "id": "formation-9"
    }}>{`Formation`}</h5>
    <p>{`Eilie > Hero`}</p>
    <h4 {...{
      "id": "golden-wolf-3500hp"
    }}>{`Golden Wolf (3500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <p>{`Eilie Attack`}</p>
    <h5 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h5>
    <p>{`Auto`}</p>
    <h3 {...{
      "id": "castle-16"
    }}>{`Castle`}</h3>
    <p>{`Go to 3rd floor to watch Kiba Shu cutscene`}<br parentName="p"></br>{`
`}{`Talk to Shu Option 1`}</p>
    <p>{`Great Hall just mash > After Kiba cutscenes leave and Blinking Mirror`}<br parentName="p"></br>{`
`}{`Go to Great Hall `}<em parentName="p">{`Shu 1 textbox`}</em>{` `}<strong parentName="p">{`Option 2`}</strong>{` to start battle`}</p>
    <h3 {...{
      "id": "rockaxe-war-battle"
    }}>{`Rockaxe War Battle`}</h3>
    <h5 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h5>
    <p>{`Gilbert (R2) 1D`}<br parentName="p"></br>{`
`}{`Luc (R2) 1L`}<br parentName="p"></br>{`
`}{`Teresa (R2) 1L`}<br parentName="p"></br>{`
`}{`Kasumi (Manual) 1D`}<br parentName="p"></br>{`
`}{`Ridley (R2) 1D`}</p>
    <h5 {...{
      "id": "turns-2--3"
    }}>{`Turns 2 & 3`}</h5>
    <p>{`End Turn`}</p>
    <h3 {...{
      "id": "rockaxe-2"
    }}>{`Rockaxe`}</h3>
    <p>{`Fork (`}<strong parentName="p">{`LEFT`}</strong>{` right)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LADDER`}</strong>{` up)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`UP`}</strong>{` ladder)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LADDER`}</strong>{` right)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`LEFT`}</strong>{` up)`}<br parentName="p"></br>{`
`}{`Fork (`}<strong parentName="p">{`RIGHT`}</strong>{` down)`}</p>
    <p><em parentName="p">{`Can save 0.5 seconds by not picking an option to protect Nanami`}</em></p>
    <h4 {...{
      "id": "gorudo-4500hp"
    }}>{`Gorudo (4500HP)`}</h4>
    <h5 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h5>
    <p>{`Hero Thor Shot`}<br parentName="p"></br>{`
`}{`Jowy Hungry Friend`}</p>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <p>{`Hero Defend`}<br parentName="p"></br>{`
`}{`Jowy Hungry Friend`}</p>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <p>{`Hero Attack`}<br parentName="p"></br>{`
`}{`Jowy Piercing Blade (lvl 3 spell)`}</p>
    <h3 {...{
      "id": "castle-17"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You have ~1 minute to do whatever here. We're going to setup Hero equipment & setup inventory so 4x Shredding is at the top of Take From Bag menu.`}</p>
    </blockquote>
    <p><em parentName="p">{`Move up 3 steps then 1 down (optimal position for cutscene), lines up with Rina`}</em></p>
    <h4 {...{
      "id": "equipment-7"
    }}>{`Equipment`}</h4>
    <h5 {...{
      "id": "hero-1"
    }}>{`Hero`}</h5>
    <ul>
      <li parentName="ul">{`Best Equip`}</li>
      <li parentName="ul">{`Equip Fire Emblem`}</li>
    </ul>
    <p><em parentName="p">{`Master Garb, Fire Emblem, and Power Ring should be equipped. The rest doesn't matter.`}</em></p>
    <h4 {...{
      "id": "items"
    }}>{`Items`}</h4>
    <p>{`Discard all consumables before `}<strong parentName="p">{`Shredding x4`}</strong>{` in the menu.`}</p>
    <p>{`When you wake up, after fade in you can move instantly so hold left to leave bed`}</p>
    <p>{`Great Hall talk to Shu after delay between textboxes,`}<br parentName="p"></br>{`
`}<em parentName="p">{`"Lord Hero, Give us the order to invade Highland."`}</em>{` `}<strong parentName="p">{`Option 3`}</strong></p>
    <p>{`After waking up leave room and go left to trigger Apple and Shu cutscene.`}<br parentName="p"></br>{`
`}{`Go back to bed, then Great Hall.`}</p>
    <p><em parentName="p">{`Shu 1 textbox`}</em>{` then `}<strong parentName="p">{`Option 2`}</strong></p>
    <p><em parentName="p">{`~30 second break between Hero "We're off!!! To L'Renouille!!!" and next input`}</em></p>
    <h3 {...{
      "id": "shu-war-battle"
    }}>{`Shu War Battle`}</h3>
    <p>{`No control, make sure Viktor has no activatable abilities like Fire Spear`}<br parentName="p"></br>{`
`}{`~1 minute break after Leon "He's not man enough to risk his own life."`}</p>
    <h3 {...{
      "id": "muse-highland-border-1"
    }}>{`Muse-Highland Border`}</h3>
    <p>{`Viktor "Are ya ready yet?" Talk to Apple then `}<strong parentName="p">{`Option 2`}</strong></p>
    <h3 {...{
      "id": "lrenouille-war-battle"
    }}>{`L'Renouille War Battle`}</h3>
    <p><em parentName="p">{`Flik Starting position is 1 up 2 right from Hero`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`R1 from Hauser to select Flik (Hauser above Hero)`}</em><br parentName="p"></br>{`
`}<em parentName="p">{`R1 from Hero to select Viktor`}</em></p>
    <h5 {...{
      "id": "turns-1-2"
    }}>{`Turns 1-2`}</h5>
    <p>{`Move Flik & Viktor towards entrance`}</p>
    <h5 {...{
      "id": "turns-3-4"
    }}>{`Turns 3-4`}</h5>
    <p>{`Flik 1 tile away from soldier & Fire Spear x2`}<br parentName="p"></br>{`
`}{`Keep moving Viktor towards entrance`}</p>
    <h5 {...{
      "id": "turn-5--on"
    }}>{`Turn 5 & on`}</h5>
    <p>{`5th turn, if soldier still not dead Viktor attack & Flik attack until dead`}<br parentName="p"></br>{`
`}{`Move into L'Renouille as soon as he dies`}</p>
    <h3 {...{
      "id": "lrenouille"
    }}>{`L'Renouille`}</h3>
    <h4 {...{
      "id": "party-12"
    }}>{`Party`}</h4>
    <p>{`Flik `}<strong parentName="p">{`X`}</strong><br parentName="p"></br>{`
`}{`Rina `}<strong parentName="p">{`1U`}</strong><br parentName="p"></br>{`
`}{`Eilie `}<strong parentName="p">{`2U`}</strong><br parentName="p"></br>{`
`}{`Lo Wen `}<strong parentName="p">{`1L2D`}</strong><br parentName="p"></br>{`
`}{`Luc `}<strong parentName="p">{`1L3D`}</strong></p>
    <h5 {...{
      "id": "formation-10"
    }}>{`Formation`}</h5>
    <p>{`Hero > Rina`}</p>
    <h4 {...{
      "id": "lucia-6600hp"
    }}>{`Lucia (6600HP)`}</h4>
    <h5 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Rina Explosion`}</li>
      <li parentName="ul">{`Flik Thor Shot`}</li>
      <li parentName="ul">{`Hero Thor Shot`}</li>
      <li parentName="ul">{`Eilie Attack`}</li>
      <li parentName="ul">{`Luc Thor Shot`}</li>
    </ul>
    <p><strong parentName="p">{`8 Soldier Battles`}</strong><br parentName="p"></br>{`
`}{`Eilie Kite Rune`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Luc Take from Bag Shredding Scroll`}</strong>{` in one of these battles.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Hero & Flik attack probably won't do enough damage to cover a Kite miss.`}</p>
    </blockquote>
    <h4 {...{
      "id": "han-duel-500hp"
    }}>{`Han Duel (500HP)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Attack`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Defend`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Wild Attack`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`I should have avoided`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Let's bury our past`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`And now it's my turn.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Unf.... you like to`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Now feel my deadly sword.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ho ho ho....`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Well struck.... it`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Watch and learn, boy.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`I can't let you past`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`You think you can beat`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You think my sword has`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Very good, boy.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Heal via Save Crystal before Seed and Culgan`}</p>
    <h4 {...{
      "id": "seed--culgan-4200hp--3800hp"
    }}>{`Seed & Culgan (4200HP & 3800HP)`}</h4>
    <h5 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Rina Explosion`}</li>
      <li parentName="ul">{`Flik Thor Shot > Culgan`}</li>
      <li parentName="ul">{`Hero Thor Shot > Seed`}</li>
      <li parentName="ul">{`Eilie Attack > Seed`}</li>
      <li parentName="ul">{`Luc Empty World`}</li>
    </ul>
    <p>{`Heal via Save Crystal before Beast Rune`}</p>
    <h4 {...{
      "id": "beast-rune"
    }}>{`Beast Rune`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 1`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Turn 2`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Rina: Explosion`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Attack > Right Head`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Flik: Thor Shot > Right Leg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Luc: The Shredding Scroll`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hero: Thor Shot > Rune`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eilie: Attack > Right Head`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lo Wen: Silent Lake`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Luc: Thor Shot > Right Leg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Turn 3 and on`}</strong><br parentName="p"></br>{`
`}{`Eilie Attack Left Head, rest Defend`}</p>
    <h3 {...{
      "id": "castle-18"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall`}<br parentName="p"></br>{`
`}{`Just mash text, after selecting Option 1 2 more textboxes then split!`}</p>
    <h3 {...{
      "id": "fin"
    }}>{`Fin`}</h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      